import {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_ERROR,
} from "../../../constant/actionTypes";

const INITIAL_STATE = {
  loading: false,
};

const userLoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case USER_LOGIN_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case USER_LOGIN_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response.data,
      };
      return obj;
    }
    case USER_LOGIN_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default userLoginReducer;
